module.exports = __webpack_public_path__ + "img/cooperative0_logo9.86b67304.jpg";